// Güncel tarih-saat damgası — indirilen dosya adları ve yazdırma başlıkları için
export const damga = () => {
  const d = new Date();
  const p = (n) => String(n).padStart(2, "0");
  return `${p(d.getDate())}.${p(d.getMonth() + 1)}.${d.getFullYear()} ${p(d.getHours())}-${p(d.getMinutes())}`;
};

// Yazdırırken sayfa başlığını geçici değiştirip PDF dosya adına tarih-saat ekler
export const yazdirBaslikli = (baslik) => {
  const eski = document.title;
  document.title = `${baslik} - ${damga()}`;
  const geri = () => {
    document.title = eski;
    window.removeEventListener("afterprint", geri);
  };
  window.addEventListener("afterprint", geri);
  window.print();
  setTimeout(() => { if (document.title !== eski) geri(); }, 2000);
};
